import { determineTextClass } from "./determineTextClass"
import { StatusVariant } from "./StatusVariant"
import { statusVariantTokens } from "./statusVariantTokens"

/**
 * Determine the secondary (darker) text color class for a status variant.
 * Used for body text on subdued backgrounds (e.g., dark blue text on a light blue alert).
 */
export function determineStatusTextSecondaryClass(variant: StatusVariant): string {
  return determineTextClass(statusVariantTokens[variant].textSecondary)
}
